/**
 * EduTool error hierarchy
 *
 * Custom exceptions for the tool. Never swallow errors silently.
 */

export class EduToolError extends Error {
  public readonly code: string;
  public readonly context?: Record<string, unknown>;

  constructor(code: string, message: string, context?: Record<string, unknown>) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    this.context = context;
  }
}

export class BridgeError extends EduToolError {
  constructor(message: string, context?: Record<string, unknown>) {
    super('BRIDGE_ERROR', message, context);
  }
}

export class DataError extends EduToolError {
  constructor(message: string, context?: Record<string, unknown>) {
    super('DATA_ERROR', message, context);
  }
}

export class I18nError extends EduToolError {
  constructor(message: string, context?: Record<string, unknown>) {
    super('I18N_ERROR', message, context);
  }
}

export class ComponentError extends EduToolError {
  constructor(componentName: string, message: string, context?: Record<string, unknown>) {
    super('COMPONENT_ERROR', `${componentName}: ${message}`, context);
  }
}
